(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["an-overlay-text-aside"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (!section) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              section.classList.add('is-visible');
              observer.unobserve(section);
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(section);
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.premium-hero').forEach(initSection);
    });

    document.addEventListener('shopify:section:load', (e) => {
      initSection(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
